import { MARKETING_CONVERSION_EVENTS } from '@arrived/models';

import { trackAffiliateConversion, trackQuoraPixelEvent } from './';

interface TrackMarketingConversionEventArgs {
  type: MARKETING_CONVERSION_EVENTS;
  email?: string;
  value?: number;
}

export const trackMarketingConversionEvent = (args: TrackMarketingConversionEventArgs) => {
  const { email, type, value } = args;

  /*
    Funnel goals that are used for marketing conversion tracking.
    Use the Switch statement to send conversion goals to the various marketing applications
   */

  trackQuoraPixelEvent({ type, email });

  switch (type) {
    case MARKETING_CONVERSION_EVENTS.TRADE_DOCS_SIGNED:
      break;
    case MARKETING_CONVERSION_EVENTS.LINKED_BANK:
      // Youtube campaign conversion
      trackAffiliateConversion('/aff_lsr?offer_id=3');
      // Benzinga campaign conversion
      trackAffiliateConversion('/aff_goal?a=lsr&offer_id=4&goal_name=bank_link&adv_id=0');
      // $30 Bank link campaign conversion
      trackAffiliateConversion('/aff_lsr?offer_id=5');
      // Investopedia Bank link conversion
      trackAffiliateConversion(`/aff_goal?a=lsr&offer_id=6&goal_name=bank-link&adv_id=0`);

      // Crowdstreet Bank link conversion
      trackAffiliateConversion(`/aff_lsr?offer_id=9`);
      break;
    case MARKETING_CONVERSION_EVENTS.EMAIL_LEAD:
      // Default Arrived affiliate lead conversion
      trackAffiliateConversion(`/aff_lsr?offer_id=1&adv_sub=${email}`);

      // Benzinga campaign lead conversion
      trackAffiliateConversion(`/aff_lsr?offer_id=4&adv_sub=${email}`);

      // Investopedia campaign lead conversion
      trackAffiliateConversion(`/aff_lsr?offer_id=6&adv_sub=${email}`);
      break;
    case MARKETING_CONVERSION_EVENTS.USER_CREATED:
      // Investopedia Create Account conversion
      trackAffiliateConversion(`/aff_goal?a=lsr&offer_id=6&goal_name=create-account&adv_id=0`);
      break;
    case MARKETING_CONVERSION_EVENTS.BROKERAGE_ACCOUNT_CREATED:
      // Investopedia Brokerage Account conversion
      trackAffiliateConversion(`/aff_goal?a=lsr&offer_id=6&goal_name=brokerage-account-created&adv_id=0`);
      break;
    case MARKETING_CONVERSION_EVENTS.HIGH_VALUE_USER:
      break;
  }
};
